export default {
  title: "Webhooks",
  subtitle: "Overview",
  path: "webhooks_overview",
  paragraph: "Webhooks are notifications triggered upon event changes that take place in our platform. There are webhooks for both customer and transactions events. They will be sent to the registered URL. If your host is not available at the time, there will be 5 other attempts, spaced in an increasingly interval.",
  request: {},
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/WebhooksOverview.js